import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { API_URL } from "../../../config";

const CancelOrderModal = ({ open, onClose, order, onCancelSuccess }) => {
  const [reason, setReason] = useState("");
  const [refund, setRefund] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [result, setResult] = useState(null);

  useEffect(() => {
    if (open) {
      setReason("");
      setRefund(false);
      setError("");
      setResult(null);
    }
  }, [open]);

  const handleClose = () => {
    if (submitting) return;
    onClose();
  };

  const handleCancelOrder = async () => {
    if (!order?.id) return;
    setSubmitting(true);
    setError("");
    try {
      const token = localStorage.getItem("accessToken");
      const response = await fetch(`${API_URL}/shopping-cart/cancel-order`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify({
          order_id: order.id,
          reason: reason || undefined,
          refund: refund,
        }),
      });

      const resp = await response.json().catch(() => null);

      if (response.status === 200 && resp?.status) {
        setResult(resp);
        if (onCancelSuccess) onCancelSuccess(resp);
      } else {
        setError(resp?.message || "Failed to cancel order");
      }
    } catch (err) {
      setError("Error cancelling order: " + err.message);
    } finally {
      setSubmitting(false);
    }
  };

  const refundInfo = result?.refund;

  return (
    <Modal isOpen={open} toggle={handleClose} centered className="modern-modal">
      <ModalHeader toggle={handleClose} className="modal-header-custom">
        <i className="fas fa-ban"></i> Cancel Order
      </ModalHeader>
      <ModalBody className="modal-body-custom">
        {error && <div className="alert-banner alert-error">{error}</div>}

        {result ? (
          <>
            <div className="alert-banner alert-success">{result.message}</div>
            {refundInfo && (
              <div style={{ marginTop: 12 }}>
                <p style={{ margin: "4px 0" }}>
                  <strong>Refund status:</strong> {refundInfo.status || "N/A"}
                </p>
                {refundInfo.amount != null && (
                  <p style={{ margin: "4px 0" }}>
                    <strong>Refund amount:</strong> {refundInfo.amount}
                  </p>
                )}
                {refundInfo.error && (
                  <p style={{ margin: "4px 0", color: "#b91c1c" }}>
                    <strong>Refund error:</strong> {refundInfo.error}
                  </p>
                )}
                {refundInfo.status === "failed" && (
                  <p style={{ margin: "8px 0 0", fontSize: 12, color: "#6b7280" }}>
                    The order is cancelled, but the refund did not go through. Please process it
                    manually via the Stripe dashboard.
                  </p>
                )}
              </div>
            )}
          </>
        ) : (
          <>
            <p style={{ margin: "0 0 12px", fontWeight: 600 }}>
              Are you sure you want to cancel Order {order?.id}?
            </p>

            <div className="form-group" style={{ marginBottom: 12 }}>
              <label htmlFor="cancel-order-reason">Reason (optional)</label>
              <textarea
                id="cancel-order-reason"
                className="form-control"
                rows={3}
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="e.g. Customer changed their mind"
                disabled={submitting}
              />
            </div>

            <div className="form-group" style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <input
                type="checkbox"
                id="cancel-order-refund"
                checked={refund}
                onChange={(e) => setRefund(e.target.checked)}
                disabled={submitting}
              />
              <label htmlFor="cancel-order-refund" style={{ margin: 0 }}>
                Refund this order (Only for Stripe)
              </label>
            </div>
          </>
        )}
      </ModalBody>
      <ModalFooter className="modal-footer-custom resend-modal-footer">
        <button
          className="btn-secondary resend-modal-btn"
          onClick={handleClose}
          disabled={submitting}
        >
          {result ? "Close" : "Back"}
        </button>
        {!result && (
          <button
            className="btn-primary-modern resend-modal-btn"
            onClick={handleCancelOrder}
            disabled={submitting}
          >
            {submitting ? "Cancelling..." : "Confirm Cancellation"}
          </button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default CancelOrderModal;
